import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../Dialog/DialogTitle";
import DialogContent from "../Dialog/DialogContent";
import DialogActions from "../Dialog/DialogActions";
import Typography from "@material-ui/core/Typography";

const styles = theme => ({
  dialog: {
    width: "424px",
    height: "210px"
  },
  additionalText: {
    fontWeight: "bold"
  }
});

const DeleteConfirmationModal = ({
  open,
  handleClose,
  onConfirm,
  classes,
  modalText,
  additionalText,
  buttonCaption = "Удалить"
}) => {
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={handleClose}>Подтверждение</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            {modalText}{" "}
            {additionalText && (
              <span className={classes.additionalText}>{additionalText}</span>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            onClick={() => {
              handleClose();
              onConfirm();
            }}
            color="pink"
          >
            {buttonCaption}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(DeleteConfirmationModal);
